import axios from 'axios';
import { API_BASE_URL } from '../../../services/api';

/**
 * Utility to download a file given its backend URL
 * This bypasses cross-origin restrictions on the HTML5 download attribute
 */
export const downloadPdfFromUrl = async (pdfUrl, filename) => {
  try {
    const token = localStorage.getItem('blum_token') || localStorage.getItem('token') || '';
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    
    // Make sure the URL includes the BASE_URL if it's a relative path
    const fullUrl = pdfUrl.startsWith('http') ? pdfUrl : `${API_BASE_URL}${pdfUrl}`;

    // Fetch the file as a Blob
    const response = await axios.get(fullUrl, {
      headers,
      responseType: 'blob'
    });

    // Create a local blob URL
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const localUrl = window.URL.createObjectURL(blob);
    
    // Create an invisible anchor tag to trigger the download
    const link = document.createElement('a');
    link.href = localUrl;
    link.setAttribute('download', filename || 'Quotation.pdf');
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(localUrl);
    
    return true;
  } catch (error) {
    console.error('Failed to download PDF:', error);
    throw error;
  }
};
